import axios from "axios";

export const getAPI = (projectId) => {
  switch (projectId) {
    case "LOCAL":
      return localAPI;
    case "ANANDA":
      return anandaAPI;
    case "SCRIPTHORIUMPI":
      return scriptAPI;
    default:
      return null;
  }
};

export const scriptAPI = axios.create({
  baseURL: "https://scripthoriumpi.solarpunk.pro:1880",
  headers: {
    "content-type": "application/json",
    authorization: "Basic W2FkbWluXTpbc2UwbWFuRm9kYXhd",
  },
});

export const localAPI = axios.create({
  baseURL: "https://manuelslourenco.solarpunk.pro:1880",
  headers: {
    "content-type": "application/json",
    authorization: "Basic bWFudWVsc2xvdXJlbmNvQGdtYWlsLmNvbTpEM2ZhdWx0UGFzcy4=",
  },
});

export const anandaAPI = axios.create({
  baseURL: "https://anandavalley.solarpunk.pro:1888",
  headers: {
    "content-type": "application/json",
    authorization: "Basic ZmFybXVzZXI6YXYuITIxMjE=",
  },
});
